import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotameter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 75,
	height: 50,
	viewBox: "0 0 75.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 36.5 4.0 L 0.0 25.0 L 36.5 46.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 25,
		rx: 25,
		ry: 25,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgRotameter;
